import {createContext} from 'react';

export const RouteReactContext = createContext<any>(null);
RouteReactContext.displayName = 'RouteReactContext';
